<template>
  <div
    class="group inline-flex cursor-pointer select-none items-center gap-2"
    @click="toggleCheckbox"
  >
    <div
      :class="[
        sizeClasses[size],
        isChecked ? activeClass + ' active' : '',
        customClass,
        'ring-primary group-[.invalid]:not-[.active]:text-red-500 flex items-center justify-center border border-gray-300 transition-colors focus-visible:outline-none focus-visible:ring focus-visible:ring-1 group-[.invalid]:border-red-500 dark:border-neutral-700',
      ]"
    >
      <slot name="icon">
        <lucide-icon icon="Check" v-if="isChecked" :size="iconSizes[size]" />
        <lucide-icon icon="X" v-else :size="iconSizes[size]" />
      </slot>
    </div>
    <label
      :class="[
        labelSizes[size],
        'flex h-full cursor-pointer items-center gap-2 font-medium leading-none group-[.invalid]:text-red-500',
      ]"
    >
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Checkbox',

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    activeClass: {
      type: String,
      default: 'bg-primary text-onPrimary border-primary',
    },
    customClass: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
  },

  data() {
    return {
      isChecked: this.modelValue,
      sizeClasses: {
        sm: 'size-4 px-0.5 py-0.5 rounded-sm',
        md: 'size-6 px-1 py-1 rounded-md',
        lg: 'size-8 px-1.5 py-1.5 rounded-lg',
      },
      iconSizes: {
        sm: 12,
        md: 16,
        lg: 20,
      },
      labelSizes: {
        sm: 'text-xs',
        md: 'text-sm',
        lg: 'text-base',
      },
    };
  },

  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        this.isChecked = newVal;
      },
    },
  },

  methods: {
    toggleCheckbox() {
      this.isChecked = !this.isChecked;
      this.$emit('update:modelValue', this.isChecked);
      this.$emit('change', this.isChecked);
    },
  },
};
</script>
